import React from 'react';
import { Link } from 'react-router-dom';
import passIcon from '../assets/pass-icon.png';
import noiseIcon from '../assets/noise-icon.png';
import ccremoteIcon from '../assets/ccremote-icon.png';
import nextholiIcon from '../assets/nextholi-icon.png';
import compresstoolsIcon from '../assets/compresstools-icon.png';
import quoteCamIcon from '../assets/quotecam-icon.png';
import jikeyixiaIcon from '../assets/jikeyixia-icon.svg';
import tailscaleDoctorIcon from '../assets/tailscale-doctor-icon.png';
import tuttiHelperIcon from '../assets/tutti-helper-icon.png';
import { TUTTI_HELPER } from '../data/tuttiHelper';
import { isEnglish } from '../i18n/locale';
import { JIKEYIXIA } from '../data/jikeyixia';
import { trackButtonClick, trackAppDownload } from '../utils/analytics';

const OurApps = () => {
  const apps = [
    { id: 'tutti-helper', name: isEnglish ? 'Tutti Activity Helper' : 'Tutti 活动助手', icon: tuttiHelperIcon, guideLink: TUTTI_HELPER.path, privacyLink: TUTTI_HELPER.privacyPath },
    {
      id: 'zipwithpassword',
      name: 'ZipWithPassword',
      icon: passIcon,
      storeLink: 'apps.apple.com',
      storeUrl: 'https://apps.apple.com/hk/app/zipwithpassword/id6745940713?mt=12',
      privacyLink: '/zipwithpassword/privacy'
    },
    {
      id: 'retronoise',
      name: 'Retro Noise',
      icon: noiseIcon,
      storeLink: 'apps.apple.com',
      storeUrl: 'https://apps.apple.com/us/app/retronoise/id6746529238',
      privacyLink: '/retronoise/privacy'
    },
    {
      id: 'ccremote',
      name: 'CC Remote',
      icon: ccremoteIcon,
      storeLink: 'apps.apple.com',
      storeUrl: 'https://apps.apple.com/us/app/cc-remote/id6760018448',
      privacyLink: '/ccremote/privacy',
      guideLink: '/ccremote'
    },
    {
      id: 'nextholi',
      name: 'NextHoli',
      icon: nextholiIcon,
      storeLink: 'apps.apple.com',
      storeUrl: null,
      privacyLink: '/nextholi/privacy'
    },
    {
      id: 'compresstools',
      name: 'Compress Tools',
      icon: compresstoolsIcon,
      storeLink: 'apps.apple.com',
      storeUrl: null,
      privacyLink: '/compresstools/privacy'
    },
    {
      id: 'quotecam',
      name: 'QuoteCam',
      icon: quoteCamIcon,
      storeLink: 'apps.apple.com',
      storeUrl: null,
      privacyLink: '/quotecam/privacy'
    },
    {id: 'jikeyixia', name: isEnglish ? JIKEYIXIA.name.en : JIKEYIXIA.name.zh, icon: jikeyixiaIcon, storeLink: 'Chrome Web Store', storeUrl: JIKEYIXIA.chromeStoreUrl, privacyLink: '/jikeyixia/privacy', guideLink: '/jikeyixia'},
    {
      id: 'tailscale-doctor',
      name: 'Tailscale Doctor',
      icon: tailscaleDoctorIcon,
      guideLink: '/tailscale-doctor',
      privacyLink: '/tailscale-doctor#permissions'
    }
  ];

  const handleAppStoreClick = (appName) => {
    trackAppDownload(appName, 'App Store');
    trackButtonClick('App Store Link', `${appName} card`);
  };

  const handlePrivacyClick = (appName) => {
    trackButtonClick('Privacy Policy', `${appName} card`);
  };

  return (
    <div className="card our-apps-card">
      <h3>Our Apps</h3>
      <div className="apps-list">
        {apps.map((app) => {
          if (app.id === 'tutti-helper') return (
            <div key={app.id} className="app-item">
              <Link to={app.guideLink} className="app-left jike-app-link">
                <div className="app-icon-container"><div className="app-store-icon"><img src={app.icon} alt="" /></div></div>
                <h4 className="app-name">{app.name}</h4>
                <p className="app-store-link">{isEnglish ? 'Chrome · All features free' : 'Chrome · 全功能免费'}</p>
              </Link>
              <div className="app-links jike-app-actions">
                <Link to={app.guideLink} className="app-privacy-link">{isEnglish ? 'Explore extension' : '查看插件与下载'}</Link>
                <Link to={app.privacyLink} className="app-privacy-link">{isEnglish ? 'Privacy & permissions' : '隐私与权限'}</Link>
              </div>
            </div>
          );
          if (app.id === 'tailscale-doctor') return (
            <div key={app.id} className="app-item">
              <Link to={app.guideLink} className="app-left jike-app-link" onClick={() => trackButtonClick('Product Page', `${app.name} card`)}>
                <div className="app-icon-container">
                  <div className="app-store-icon"><img src={app.icon} alt="" /></div>
                </div>
                <h4 className="app-name">{app.name}</h4>
                <p className="app-store-link">{isEnglish ? 'macOS · Preview' : 'macOS · 预览版'}</p>
              </Link>
              <div className="app-links jike-app-actions">
                <Link to={app.guideLink} className="app-privacy-link" onClick={() => trackButtonClick('Product Page', `${app.name} card`)}>{isEnglish ? 'View Mac tool' : '查看 Mac 工具'}</Link>
                <a href={app.privacyLink} className="app-privacy-link" onClick={() => handlePrivacyClick(app.name)}>{isEnglish ? 'Privacy & permissions' : '隐私与权限'}</a>
              </div>
            </div>
          );
          if (app.id === 'jikeyixia') return <div key={app.id} className="app-item">
            <Link to={app.guideLink} className="app-left jike-app-link"><div className="app-icon-container"><div className="app-store-icon jikeyixia-icon"><img src={app.icon} alt="" /></div></div><h4 className="app-name">{app.name}</h4><p className="app-store-link">{app.storeLink}</p></Link>
            <div className="app-links jike-app-actions"><a href={app.storeUrl} target="_blank" rel="noopener noreferrer" className="app-privacy-link">{isEnglish ? 'Chrome Web Store' : 'Chrome 应用商店'}</a><Link to={app.privacyLink} className="app-privacy-link" onClick={() => handlePrivacyClick(app.name)}>Privacy Policy</Link></div>
          </div>;
          const cardContent = (
            <div className="app-left">
              <div className="app-icon-container">
                <div className={`app-store-icon ${app.id}-icon`}>
                  <img src={app.icon} alt={app.name} />
                </div>
              </div>
              <h4 className="app-name">{app.name}</h4>
              {app.storeUrl ? (
                <a
                  href={app.storeUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="app-store-link"
                  onClick={(e) => { e.stopPropagation(); handleAppStoreClick(app.name); }}
                >
                  {app.storeLink}
                </a>
              ) : (
                <p className="app-store-link">{app.storeLink}</p>
              )}
              <div className="app-links">
                <Link
                  to={app.privacyLink}
                  className="app-privacy-link"
                  onClick={(e) => { e.stopPropagation(); handlePrivacyClick(app.name); }}
                >
                  Privacy Policy
                </Link>
              </div>
            </div>
          );

          if (app.guideLink) {
            return (
              <Link key={app.id} to={app.guideLink} className="app-item app-item-link">
                {cardContent}
              </Link>
            );
          }
          if (app.storeUrl) {
            return (
              <a key={app.id} href={app.storeUrl} target="_blank" rel="noopener noreferrer" className="app-item app-item-link" onClick={() => handleAppStoreClick(app.name)}>
                {cardContent}
              </a>
            );
          }
          return (
            <div key={app.id} className="app-item">
              {cardContent}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OurApps;
